// Lessons are ordinary Square catalog items, separated from the rest of the
// shop only by their category: the Lessons page sells them, and the Gallery
// leaves them out so the same item isn't for sale in two places.
export const LESSON_CATEGORY = 'lessons';
